import ContainerFlex from '~/components/containerFlex';
import moment from 'moment';

import { currencyMask } from '~/utils/masks';
import { IResponseDetailsCampaing } from '../previewCommunication';

export type TInfoDetailsCampaingProps = {
  data: IResponseDetailsCampaing;
  isDefineCommunication?: boolean;
};

const InfoDetailsCampaing = ({
  data,
  isDefineCommunication = false,
}: TInfoDetailsCampaingProps): JSX.Element => {
  return (
    <ContainerFlex marginTop={20}>
      {data?.criterioPesquisa?.segmentacoes.length > 0 && (
        <span>
          Base de critérios&nbsp;
          <strong>{data?.criterioPesquisa?.segmentacoes.join(', ')}</strong>
        </span>
      )}
      {isDefineCommunication && (
        <>
          <span>
            Nome da campanha&nbsp;
            <strong>{data?.nome}</strong>
          </span>
          <span>
            {data?.dataAgendamento
              ? `Data e Hora agendamento\u00A0`
              : `Data e Hora validade\u00A0`}
            <strong>
              {moment(data?.dataAgendamento || data?.dataValidade).format(
                'DD/MM/YYYY HH:mm:ss',
              )}
            </strong>
          </span>
        </>
      )}
      {data?.criterioPesquisa?.filtrosPesquisa?.bairros.length > 0 && (
        <span>
          Bairros&nbsp;
          <strong>
            {data?.criterioPesquisa?.filtrosPesquisa?.bairros.join(', ')}
          </strong>
        </span>
      )}
      {data?.criterioPesquisa?.filtrosPesquisa?.cidades.length > 0 && (
        <span>
          Cidades&nbsp;
          <strong>
            {data?.criterioPesquisa?.filtrosPesquisa?.cidades.join(', ')}
          </strong>
        </span>
      )}
      {data?.criterioPesquisa?.filtrosPesquisa?.estados.length > 0 && (
        <span>
          Estados&nbsp;
          <strong>
            {data?.criterioPesquisa?.filtrosPesquisa?.estados.join(', ')}
          </strong>
        </span>
      )}
      {data?.criterioPesquisa?.filtrosPesquisa?.statusCartao.length > 0 && (
        <span>
          Status do cartão&nbsp;
          <strong>
            {data?.criterioPesquisa?.filtrosPesquisa?.statusCartao.join(', ')}
          </strong>
        </span>
      )}
      {data?.criterioPesquisa?.filtrosPesquisa?.rangeLimiteDisponivel.length ===
        2 && (
        <span>
          Limite disponível entre&nbsp;
          <strong>
            {currencyMask(
              data?.criterioPesquisa?.filtrosPesquisa?.rangeLimiteDisponivel[0],
            )}
            &nbsp;até&nbsp;
            {currencyMask(
              data?.criterioPesquisa?.filtrosPesquisa?.rangeLimiteDisponivel[1],
            )}
          </strong>
        </span>
      )}
      <span>
        Status&nbsp;
        <strong>{data?.status}</strong>
      </span>
      <span>
        Clientes atingidos&nbsp;
        <strong>{data?.totalAtingidos}</strong>
      </span>
      <span>
        Tipo de criação&nbsp;
        <strong>{data?.isManual ? 'Manual' : 'Automática'}</strong>
      </span>
    </ContainerFlex>
  );
};

export default InfoDetailsCampaing;
